 <dashboardnav>
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase = "activity">
      <!-- <pre>{{isLoadingProjectManagement$ | async | json}}</pre> -->
      <mrsoftapps-view-project-activity-summary
      [countries]="country$ | async"
      [states]="state$ | async"
      [lgas]="lga$ | async"
      [projectTypes]="projectType$ | async"
      [projectCategories]="projectCategory$ | async"
      [oilBlocks]="oilBlock$ | async"
      [oilFields]="oilField$ | async"
      [communities]="community$ | async"
      [clusters]="cluster$ | async"
      [currencies]="currency$ |async"
      [projectData]="projectData"
      [projectActivities]="projectActivity$ |async"
      [clusterCommunity]="clusterCommunity$ | async"
      [projectManagements]="projectManagement$ | async"
      [gmous]="gmou$ | async"
      [documentCategory]="documentCategory$ | async"
      [documentSubCategory]="documentSubCategory$ | async"
      (onActivityEmit)="onEmitActivity($event)"
      (deleteActivityEvent)="onDeleteActivityEvent($event)"
      (taskEmit)="taskEvent($event)"
      (dispatchEdit)="onEditEvent($event)"
      *ngIf="
      !(isLoadingProjectManagement$ | async) &&
      !(isLoadingCountry$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingCommunity$ | async) &&
      !(isLoadingProjectType$ | async) &&
      !(isLoadingCluster$ | async) &&
      !(isLoadingClusterCommunity$ | async) &&
      !(isLoadingProjectCategory$ | async) &&
      !(isLoadingOilBlock$ | async) &&
      !(isLoadingOilField$ | async) &&
      !(isLoadingDocumentCategory$ | async) &&
      !(isLoadingDocumentSubCategory$ | async) &&
      !(isLoadingGmou$ | async) &&
      !(isLoadingCurrency$ | async) &&
      !(isLoadingProjectActivity$ | async)

"
      >


      </mrsoftapps-view-project-activity-summary>

    </ng-template>

    <ng-template ngSwitchCase = "create">
      <!-- <pre>{{isLoadingProjectManagement$ | async | json}}</pre> -->
      <mrsoftapps-new-project
      [countries]="country$ | async"
      [states]="state$ | async"
      [lgas]="lga$ | async"
      [projectTypes]="projectType$ | async"
      [projectCategories]="projectCategory$ | async"
      [oilBlocks]="oilBlock$ | async"
      [oilFields]="oilField$ | async"
      [communities]="community$ | async"
      [clusters]="cluster$ | async"
      [currencies]="currency$ |async"
      [clusterCommunity]="clusterCommunity$ | async"
      [projectManagements]="projectManagement$ | async"
      [selectedGMOUId]="selectedGMOUId"
      [gmous]="gmou$ | async"
      [projectActivities]="projectActivity$ |async"
      [projectData]="projectData"
      [documentCategory]="documentCategory$ | async"
      [documentSubCategory]="documentSubCategory$ | async"
      (changeEmit)="onTriggerEmit($event)"
      (onActivityEmit)="onEmitActivity($event)"
      (deleteActivityEvent)="onDeleteActivityEvent($event)"
      (taskEmit)="taskEvent($event)"
      *ngIf="
      !(isLoadingProjectManagement$ | async) &&
      !(isLoadingCountry$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingCommunity$ | async) &&
      !(isLoadingProjectType$ | async) &&
      !(isLoadingCluster$ | async) &&
      !(isLoadingClusterCommunity$ | async) &&
      !(isLoadingProjectCategory$ | async) &&
      !(isLoadingOilBlock$ | async) &&
      !(isLoadingOilField$ | async) &&
      !(isLoadingDocumentCategory$ | async) &&
      !(isLoadingDocumentSubCategory$ | async) &&
      !(isLoadingGmou$ | async) &&
      !(isLoadingCurrency$ | async) &&
      !(isLoadingProjectActivity$ | async)
"
      >


      </mrsoftapps-new-project>

    </ng-template>
  </div>


  <div [ngSwitch]="task">
    <ng-template ngSwitchCase = "list">
      <!-- <pre>{{isLoadingProjectManagement$ | async | json}}</pre> -->
      <mrsoftapps-view-projects
      [countries]="country$ | async"
      [states]="state$ | async"
      [lgas]="lga$ | async"
      [projectTypes]="projectType$ | async"
      [projectCategories]="projectCategory$ | async"
      [oilBlocks]="oilBlock$ | async"
      [oilFields]="oilField$ | async"
      [communities]="community$ | async"
      [clusters]="cluster$ | async"
      [currencies]="currency$ |async"
      [clusterCommunity]="clusterCommunity$ | async"
      [projectManagements]="projectManagement$ | async"
      [gmous]="gmou$ | async"
      [documentCategory]="documentCategory$ | async"
      [documentSubCategory]="documentSubCategory$ | async"
      (changeEmit)="onTriggerEmit($event)"
      (onActivityEmit)="onEmitActivity($event)"
      (viewEvent)="onViewProject($event)"
      (deleteProjectEvent)="deleteProjectEvent($event)"
      (taskEmit)="taskEvent($event)"
      (createProjectEmit)="oncreateProjectEmit($event)"
      (dispatchEdit)="onEditEvent($event)"
      *ngIf="
      !(isLoadingProjectManagement$ | async) &&
      !(isLoadingCountry$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingCommunity$ | async) &&
      !(isLoadingProjectType$ | async) &&
      !(isLoadingCluster$ | async) &&
      !(isLoadingClusterCommunity$ | async) &&
      !(isLoadingProjectCategory$ | async) &&
      !(isLoadingOilBlock$ | async) &&
      !(isLoadingOilField$ | async) &&
      !(isLoadingDocumentCategory$ | async) &&
      !(isLoadingDocumentSubCategory$ | async) &&
      !(isLoadingGmou$ | async) &&
      !(isLoadingCurrency$ | async)

"
      >


      </mrsoftapps-view-projects>

    </ng-template>

  </div>



<mrsoftapps-epims-reference-spinner
*ngIf="
(isLoadingProjectManagement$ | async) ||
(isLoadingCountry$ | async) ||
(isLoadingState$ | async) ||
(isLoadingLga$ | async) ||
(isLoadingCommunity$ | async) ||
(isLoadingProjectType$ | async) ||
(isLoadingCluster$ | async) ||
(isLoadingClusterCommunity$ | async) ||
(isLoadingProjectCategory$ | async) ||
(isLoadingOilBlock$ | async) ||
(isLoadingOilField$ | async) ||
(isLoadingDocumentCategory$ | async) ||
(isLoadingDocumentSubCategory$ | async) ||
(isLoadingGmou$ | async) ||
(isLoadingCurrency$ | async) ||
(isLoadingProjectActivity$ | async)
"


></mrsoftapps-epims-reference-spinner>
</main>
</div>
</dashboardnav>
